import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=2da0af13&scoped=true&"
import script from "./productManage.vue?vue&type=script&lang=js&"
export * from "./productManage.vue?vue&type=script&lang=js&"
import style0 from "./productManage.vue?vue&type=style&index=0&id=2da0af13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0af13",
  null
  
)

export default component.exports